import React from 'react';

export const HomeFooter: React.FC = () => (
  <footer className="pt-8 pb-12 border-t border-neutral-100">
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-6 text-[12px] text-neutral-400">
        <a
          href="https://skylarq.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-neutral-600 transition-colors"
        >
          Skylarq
        </a>
        <a
          href="mailto:support@skylarq.ai"
          className="hover:text-neutral-600 transition-colors"
        >
          Support
        </a>
      </div>
      <p className="text-[11px] text-neutral-300">
        Built with care in San Francisco
      </p>
    </div>
  </footer>
);
